import { Spinner } from "@fluentui/react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IApplicationState } from "src/state";
import { initiateLogin } from "src/state/auth";

interface IPropsFromState {
    isSigningIn: boolean;
}

interface IPropsFromDispatch {
    initiateLogin: typeof initiateLogin;
}

type SignUpCompleteProps = IPropsFromDispatch & IPropsFromState;

const SignupCompletePage = ({ isSigningIn, initiateLogin }: SignUpCompleteProps) => {
    // Preserve locale from URL so it survives the MSAL redirect round-trip
    const localeMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//i);
    if (localeMatch) {
        sessionStorage.setItem("locale", localeMatch[1].toLowerCase());
    }
    sessionStorage.setItem("IsSignupRedirection", "true");
    initiateLogin();

    return <Spinner />
}

const mapStateToProps = ({ auth }: IApplicationState): IPropsFromState => ({
    isSigningIn: auth.isSigningIn
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    initiateLogin: () => dispatch(initiateLogin())
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupCompletePage);